import { AssetIcon } from 'assets/icons/AssetIcon';
import useConditionalTimeout from 'beautiful-react-hooks/useConditionalTimeout';
import cx from 'classnames';
import PopoverBox from 'components/popover/PopoverBox';
import Typography, { TypographyColor } from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import {
  TIME_SHOW_POPOVER_GUIDE_DURATION,
  TIME_TO_SHOW_PHOTO,
} from 'constants/photo.const';
import { useBoothAppContext } from 'context/BoothAppContext';
import { processedImageUrl } from 'helpers/url.helper';
import { useTranslation } from 'hooks/useTranslation';
import { includes, map } from 'lodash';
import React, { useRef, useState } from 'react';
import { useAppSelector } from 'store/store-hooks';
import { useShootingContext } from './ShootingContext';
import { useShootingActions } from './useShootingActions';

interface PhotoThumbnailListProps {
  triggerShowTheme: boolean;
}

const PhotoThumbnailList: React.FC<PhotoThumbnailListProps> = () => {
  const { t } = useTranslation();
  const thumbImgRef = useRef<HTMLDivElement>(null);
  const btnThemeThumbnail = useRef<HTMLButtonElement>(null);
  const { isVerticalScreen } = useAppSelector((s) => s.booth);
  const { transactionId, isRetakePhoto, isShootingOfRetakingPhoto } =
    useAppSelector((s) => s.selfeApp);
  const { listPhotoTakens } = useBoothAppContext();
  const {
    listIndexOfRetake,
    selectImageIndex,
    imageHash,
    numberOfTakePicture,
    sizeOfNeedToTakePhoto,
  } = useShootingContext();
  const { handleSelectResultOfPhoto } = useShootingActions();

  const [isShowThumbnailRect, setIsShowThumbnailGuideRect] = useState(false);

  // Show kết quả chụp ảnh
  useConditionalTimeout(
    () => setIsShowThumbnailGuideRect(true),
    TIME_TO_SHOW_PHOTO,
    !isRetakePhoto && sizeOfNeedToTakePhoto >= numberOfTakePicture,
  );

  // Close popover guide
  useConditionalTimeout(
    () => setIsShowThumbnailGuideRect(false),
    TIME_SHOW_POPOVER_GUIDE_DURATION,
    isShowThumbnailRect,
  );

  return (
    <div className="recently-photo-wrapper">
      <div ref={thumbImgRef} className="flex recently-photo">
        {map(Array(numberOfTakePicture).fill(null), (_, ind) => {
          const takenImg = listPhotoTakens?.data?.[ind] || '';
          const isThisPicRetakePhoto =
            !!takenImg && isRetakePhoto && includes(listIndexOfRetake, ind);
          const isShootingPhoto =
            isThisPicRetakePhoto &&
            isShootingOfRetakingPhoto &&
            listIndexOfRetake?.[0] === ind;

          return (
            <button
              key={ind}
              ref={btnThemeThumbnail}
              type="button"
              className={cx('flex items-center justify-center photo-slot', {
                'not-has-photo': !takenImg,
                'has-photo': !!takenImg,
                'retaking-photo-thumb': isShootingPhoto,
                'selected-photo':
                  isRetakePhoto &&
                  !isShootingOfRetakingPhoto &&
                  selectImageIndex === ind,
              })}
              onClick={handleSelectResultOfPhoto(ind)}
            >
              {/* {isDisplayOnLiveview && (
                <ShowThemeOnArea
                  liveviewSize={btnThemeThumbnail?.current?.getBoundingClientRect()}
                  takingPhotoIndex={ind}
                  isShowInLiveView={false}
                />
              )} */}
              {takenImg ? (
                <img
                  src={processedImageUrl(transactionId, takenImg, imageHash)}
                  alt="thumb"
                />
              ) : (
                <AssetIcon.TakePhotoThumbnailHolderIcon className="photo-slot__icon-take-photo-holder" />
              )}
              {isThisPicRetakePhoto && (
                <div
                  className={cx('photo-slot-retake-layer', {
                    'blink-opacity': isShootingPhoto,
                  })}
                >
                  <AssetIcon.RoundIcon />
                </div>
              )}
            </button>
          );
        })}

        {/* Hiển thị tiến độ */}
        <div className="grow flex items-center justify-center count-recently-photo">
          <Typography
            variant={TYPOGRAPHY_VARIANTS.BODY}
            color={TypographyColor.SECONDARY}
          >
            {sizeOfNeedToTakePhoto}/{numberOfTakePicture}
          </Typography>
        </div>
      </div>
      <PopoverBox
        className="pb-popover-shooting-page"
        anchorDimension={thumbImgRef?.current?.getBoundingClientRect?.()}
        popoverDir={isVerticalScreen ? 'bottom' : 'right'}
        content={`${t('page:clickWatchImageGuideInfo')}`}
        open={isShowThumbnailRect}
      />
    </div>
  );
};

export default React.memo(PhotoThumbnailList);
